/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-font-family',
  templateUrl: './theme-option-tooltips-title-font-family.component.html',
  styleUrls: ['./theme-option-tooltips-title-font-family.component.css']
})
export class ThemeOptionTooltipsTitleFontFamilyComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleFontFamily';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_titleFontFamily', value);
  }


}
